import { Layer } from "./Layer.js";
import { FeatureLayerUtils } from "./utils/FeatureLayerUtils.js";

export { FilterLayer }

/**
 * Attribute Filter
 * 
 * @author rhess <robin.hess@awi.de>
 * @memberof vef.map.layer
 */
class FilterLayer extends Layer {

    /**
     * Set all properties for the layer based on the options object.
     * 
     * @param {object} config 
     * @param {object} cache 
     * @param {string} id 
     */
    constructor(config, cache, id) {
        // calling parent constructor
        super(config, cache, id);

        // init default values and define getters and setters
        this.addDefaults_({
            targetLayer: "",
            column: "",
            values: [],
            // overwrite default
            icon: "fas fa-filter",
            availableCrs: FeatureLayerUtils.availableCrs
        });

        this.setAll_("type", "filter");

        // ignore availableCrs and always use the default value
        if ("availableCrs" in this.config) delete this.config.availableCrs;
        if ("availableCrs" in this.cache) delete this.cache.availableCrs;

        this.setAll_("type", "filter");
    }

}